import Model, { attr, belongsTo } from '@warp-drive/legacy/model';

export default class ExternalReferenceModel extends Model {
  @attr('string') param;
  @attr('string') val;
  @attr('number') position;

  // Relations
  @belongsTo('artist', { async: true, inverse: 'externalReferences' }) artist;
  @belongsTo('label', { async: true, inverse: 'externalReferences' }) label;
  @belongsTo('division', { async: true, inverse: 'externalReferences' })
  division;
  @belongsTo('category', { async: true, inverse: null }) type;
}
